// extracted by mini-css-extract-plugin
module.exports =  {"nonInteractive":"nonInteractive_mH7WbEzH"};